import { access } from "fs";

export class CommonConstants {
  //API Resonse
  static API_RESPONSE_SUCCESSFULL = 200; //Successfull response code
  static API_RESPONSE_ACCEPTED = 202; // Response Accepted Code
  static API_RESPONSE_UNAUTHORIZED_ACCESS = 401; //Response Unauthorized Access
  static API_RESPONSE_CONFLICTS_IN_REQUEST = 409; // Response having conflicts
  static API_RESPONSE_BAD_REQUEST = 400;
  static API_RESPONSE_INTERNAL_SERVER_ERROR = 500;
  static API_RESPONSE_SUCCESS_STRING = "success";
  static API_RESPONSE_FORBIDDEN_IN_REQUEST = 403;

  // Candidate Status for Finalization
  static FINALIZE_STATUS_ONHOLD = 41;
  static FINALIZE_STATUS_OFFERED = 42;
  static FINALIZE_STATUS_ACCEPTED = 43;
  static FINALIZE_STATUS_DECLINED = 44;
  static FINALIZE_STATUS_JOINED = 45;
  static FINALIZE_STATUS_DROP_OUT = 46;
  static CANDIDATE_STATUS_BLACK_LIST = 109;
  static CANDIDATE_STATUS_NEW_CANDIDATE = 111; //New Candidate status

  static STATUS_RESCHEDULE_INTERVIEW = 118;
  static REASON_CANDIDATE_NOT_AVAILABLE = 38;
  static GROUP_DETAIL_ID_OF_MASTER_54 = 6;
  static STATUS_INTERVIEW_SCHEDULED = 31;

  // Assessment Status
  static STATUS_CANDIDATE_REJECTED = 34;

  // Meeting credentials
  static MS_TEAMS = 92;
  static GOOGLE_MEET = 91;
  static ZOOM = 150;
  static PERSONAL = 90;

  // Credentials
  static MICROSOFT = "Microsoft";
  static DEFAULT = "Default";

  static TRIAL = "Trial";

  static REQUEST_CLOSE_STATUS = 25;

  static SYNOVERGE_SUBDOMAIN = "synoverge";

  static VIRTUAL_SCHEDULETYPE = "Virtual Agent Interview";
  static VIRTUAL_ROUNDNAME = "Virtual-Screening";
  static Management_ROUND = 2;
  static TECHNICAL_ROUND_1 = 1;
  static TECHNICAL_ROUNDCOUNT_1 = 1;
}

export const authorizationConstant = {
  masterPageList: [
    "JD Template",
    "Manage Project",
    "Manage Sources",
    "Manage Skill",
    "Manage Education",
    "Manage Technology",
    "Manage Lead Time",
    "Manage Designation",
    "Letter Configuration",
  ],
  resourcePageList: ["Manage User", "Interview Panel"],
  candidatePageList: ["Manage Candidate", "Calling Candidate"],
  rolePageList: ["Manage Role", "Role Activity"],
  accessPageList: ["Platform Integrations", "Auth Configuration"],
  systemConfigurationPageList: [
    "Email Configuration",
    "Cron Configuration",
  ],
  permissionAll: "all",
  dataScopeAll: "all",
  dataScopeOwn: "own",
  permissionDisplayCTC: "display CTC",
  permissionSchedule: "Schedule",
  permissionFinalizeCandidate: "Finalize Candidate",
  roleSystemAdmin: "System Admin",
  roleSuperAdmin: "Super Admin",
  roleSuperAdminId: 1,
  permissionSwimlaneGraph: "Swimlane Graph",
  permissionJobOpeningsGraph: "Job Openings Graph",
  permissionCallingStatementCard: "Calling Statement Card",
  permissionInterviewScheduledCard: "Interview Scheduled Card",
  permissionPendingFeedbackCard: "Pending Feedback Card",
  permissionJobOpeningCard: "Job Opening Card",
  permissionShortlistedCandidateCard: "Shortlisted Candidate Card",
  permissionWithinTATCard: "Within TAT Card",
  permissionOverdueTATCard: "Overdue TAT Card",
  permissionOfferAcceptanceRatioCard: "Offer Acceptance Ratio Card",
  permissionCriticalRequestGraph: "Critical Request Graph",
  permissionInterviewFunnelGraph: "Interview Funnel Graph",
  permissionCandidateFinalizationStatusGraph:
    "Candidate Finalization Status Graph",
  permissionSourceClosureGraph: "Source Closure Graph",
  permissionRecruiterAssignedGraph: "Recruiter Assigned Graph",
  permissionOfferedCandidateListGraph: "Offered Candidate List Graph",
  permissionCallingCandidateStatusGraph: "Calling Candidate Status Graph",
  permissionOpenRequest: "Open Request",
  permissionInProgressRequest: "In Progress Request",
  permissionClosedRequest: "Closed Request",
  dashboardPageId: 13,
  permissionView: "view",
  dashboardRecruiterNotAccess: [
    "Within TAT Card",
    "Overdue TAT Card",
    "Recruiter Assigned Graph",
  ],

  dashboardOthersAccess: [
    "Interview Scheduled Card",
    "Pending Feedback Card",
    "Offered Candidate List Graph",
    "Open Request",
    "In Progress Request",
    "Closed Request",
    "Job Opening Card",
    "Job Openings Graph",
  ],
};

export enum AuthType {
  MICROSOFT = "Microsoft",
  DEFAULT = "Default",
}

export const tourGroups = [
  "ResumeScreening",
  "resourceManagement",
  "candidateManagement",
  "roleManagement",
  "masterData",
  "accessManagement",
  "systemConfiguration",
];

export const steps = [
  {
    id: "Welcome",
    element: "Welcome",
    popover: {
      title: "Welcome to TalentStrokes!",
      description: `
<div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Hey there! 👋 Ready to streamline your hiring?</strong></p>
  <p>This platform helps you manage job roles, track candidates, schedule interviews, and collaborate with your team—all in one place.</p>
  <p>With powerful insights and an easy-to-use dashboard, you're all set to hire smarter and faster.</p>
  <p>Let’s take a quick tour and show you around!</p>
</div>
`,
      position: "center",
    },
  },
  {
    element: "#Dashboard",
    popover: {
      title: "Dashboard",
      description: `
     <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Monitor your key recruitment metrics at a glance:</strong></p>
  <p>Stay updated with important stats like open and in-progress requests, scheduled interviews, pending feedback, shortlisted candidates, and your offer acceptance rate—all on one dashboard.</p>
  
  <p><strong>Gain valuable visual insights:</strong></p>
  <p>Get a clear view of critical requests, offered candidates, source closures, the interview funnel, and job openings to make smarter decisions, faster.</p>
</div>
    `,
    },
  },
  {
    element: "#MyInterview",
    popover: {
      title: "My Interview",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Manage your interviews effortlessly:</strong></p>
  <p>Stay on top of your upcoming interviews, review candidate details, and submit feedback—all in one place. You can also easily track pending feedbacks and monitor interview progress to ensure everything runs smoothly.</p>
</div>
`,
    },
  },
  {
    element: "#ManageRequest",
    popover: {
      title: "Manage Request",
      description: `
       <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Manage your job opening requests with ease:</strong></p>
  <p>Create, approve, edit, or delete job requests, and set the number of openings and target dates. You can also revise existing requests and assign recruiters to specific job openings, all in a few clicks.</p>
</div>
      `,
    },
  },
  {
    element: "#ResumeScreening",
    popover: {
      title: "Resume Screening",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
          <p><strong>Streamline your resume screening process effortlessly:</strong></p>
          <p>Use SmartResumeParser to upload resumes or select from existing profiles, match candidates to job requirements, and instantly extract key details for review. Parsed data can be saved for future access.</p>
          <p>Access ResumeDashboard to manage and edit saved resume data, confirm candidate details, and add qualified candidates to your pipeline with a single click.</p>
        </div>
      `,
    },
    group: "ResumeScreening",
  },
  {
    id:'SmartResumeParser',
    element: "#SmartResumeParser",
    popover: {
      title: "Smart Resume Parser",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Quickly parse and review resumes with SmartResumeParser:</strong></p>
        <p>Select a job requirement, then upload a resume or choose from existing candidate profiles. Click the "Analyze" button to extract structured resume data instantly. You can review and save the parsed information for later use.</p>
      </div>

      `,
    },
    group: "ResumeScreening",
  },
  {
    id:'ResumeDashboard',
    element: "#ResumeDashboard",
    popover: {
      title: "Resume Dashboard",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Manage and update candidate profiles with ResumeDashboard:</strong></p>
        <p>View all saved parsed resumes in one place. Edit candidate details, validate extracted information, and confirm changes. Once finalized, add the candidate to your hiring pipeline with a single click.</p>
      </div>

      `,
    },
    group: "ResumeScreening",
  },
  {
    id: "resourceManagement",
    element: "#resourceManagement",
    popover: {
      title: "Resource Management",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Manage Your Organization’s Workforce</strong></p>
  <p>This section allows you to manage user details and coordinate interview panel responsibilities based on your access rights.</p>
</div>`,
    },
    group: "resourceManagement",
  },
  {
    id: "ManageUser",
    element: "#ManageUser",
    popover: {
      title: "Manage User",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Seamlessly handle user management:</strong></p>
  <p>Add employees in bulk or via SSO, assign specific roles, or manually add individual users. You can also easily edit or delete user profiles as needed.</p>
</div>
    `,
    },
    group: "resourceManagement",
  },
  {
    id: "InterviewPanel",
    element: "#InterviewPanel",
    popover: {
      title: "Interview Panel",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Create and manage interview panels for different stages:</strong></p>
        <p>Easily set up HR, Technical, and Management panels for various stages of the hiring process. You can also configure panels for Virtual Bot Interviews and apply them when scheduling interviews, ensuring a seamless interview experience.</p>
      </div>
    `,
    },
    group: "resourceManagement",
  },
  {
    id: "candidateManagement",
    element: "#candidateManagement",
    popover: {
      title: "Candidate Management",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Centralized control over candidate interactions and information.</strong></p>
        <p>This section lets you manage candidate details and streamline communication by initiating or tracking candidate calls directly from the system.</p>
      </div>`,
    },
    group: "candidateManagement",
  },
  {
    element: "#CallingCandidate",
    popover: {
      title: "Calling Candidate",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Streamline candidate call management:</strong></p>
  <p>View candidate details, assign them to job requests, and easily convert them into candidates when needed—all in one place.</p>
</div>
    `,
    },
    group: "candidateManagement",
  },
  {
    element: "#ManageCandidate",
    popover: {
      title: "Manage Candidate",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Seamlessly manage candidate information:</strong></p>
        <p>Easily add, edit, or delete candidate information. Schedule, reschedule, or cancel interviews, and capture personal, professional, and educational details. You can also map candidates to job requirements and schedule interviews directly from this section.</p>
      </div>
      `,
    },
    group: "candidateManagement",
  },
  {
    id: "roleManagement",
    element: "#roleManagement",
    popover: {
      title: "Role Management",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Define and organize job roles to align with hiring needs.</strong></p>
  <p>This section allows you to manage role structures, responsibilities, and associated requirements to ensure consistency across candidate evaluations and interview planning.</p>
  <p>Each section provides flexible configuration to match your unique workflow needs.</p>
</div>
`,
    },
    group: "roleManagement",
  },
  {
    id: "Manage Role",
    element: "#ManageRole",
    popover: {
      title: "Manage Role",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Manage user roles within the system:</strong></p>
        <p>Easily create, edit, or remove roles to suit your organizational structure. Role permissions are managed separately to give you flexible control over access and responsibilities.</p>
      </div>

    `,
    },
    group: "roleManagement",
  },
  {
    id: "RoleActivity",
    element: "#RoleActivity",
    popover: {
      title: "Role Activity",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Control what each role can access and perform:</strong></p>
        <p>Define and manage specific permissions for every role in the system. Fine-tune access across features and modules to ensure secure, role-based control throughout your recruitment workflow.</p>
      </div>
`,
    },
    group: "roleManagement",
  },
  {
    id: "masterData",
    element: "#masterData",
    popover: {
      title: "Master Data",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Configure core reference data used throughout the platform.</strong></p>
  <p>This section includes centralized management of foundational data such as skills, technologies, designations, education, and sources, ensuring consistency across all modules.</p></div>`,
    },
    group: "masterData",
  },
  {
    id: "JDTemplate",
    element: "#JDTemplate",
    popover: {
      title: "JD Template",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Create and manage reusable job description templates:</strong></p>
  <p>Easily define roles, responsibilities, and skill requirements to build comprehensive job descriptions. Once your templates are set up, you can quickly apply them when raising job requests, saving you time and ensuring consistency across your postings.</p>
</div>
    `,
    },
    group: "masterData",
  },
  {
    id: "ManageLeadTime",
    element: "#ManageLeadTime",
    popover: {
      title: "Manage Lead Time",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Set and manage expected timelines for each hiring stage:</strong></p>
        <p>Easily define lead times for interview rounds and other hiring processes. Track and optimize turnaround times across the entire workflow to ensure a smoother and faster recruitment process.</p>
      </div>
    `,
    },
    group: "masterData",
  },
  {
    id: "ManageTechnology",
    element: "#ManageTechnology",
    popover: {
      title: "Manage Technology",
      description: `
     <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
      <p><strong>Add and organize technologies used in your hiring process:</strong></p>
      <p>Create technology tags for job roles and candidate profiles to improve filtering and matching. This makes it easier to find the right candidates and streamline your hiring decisions.</p>
    </div>

    `,
    },
    group: "masterData",
  },
  {
    id: "ManageSkill",
    element: "#ManageSkill",
    popover: {
      title: "Manage Skill",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Define and organize key skills across the platform:</strong></p>
        <p>Add both technical and non-technical skills, then tag them to job roles and candidate profiles. This enhances filtering, improves matching accuracy, and helps streamline candidate evaluation.</p>
      </div>

    `,
    },
    group: "masterData",
  },
  {
    id: "ManageProject",
    element: "#ManageProject",
    popover: {
      title: "Manage Project",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Create and manage hiring projects or business units:</strong></p>
  <p>Group related job requests under specific projects or units, assign responsible teams, and track hiring progress at a project level for better organization and ownership.</p>
</div>

`,
    },
    group: "masterData",
  },
  {
    id: "ManageDesignation",
    element: "#ManageDesignation",
    popover: {
      title: "Manage Designation",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
      <p><strong>Define and manage designations across job roles:</strong></p>
      <p>Create standardized titles, link them with job openings and descriptions, and ensure consistency across roles and organizational levels.</p>
    </div>

  `,
    },
    group: "masterData",
  },
  {
    id: "ManageEducation",
    element: "#ManageEducation",
    popover: {
      title: "Manage Education",
      description: `
 <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Standardize education requirements across roles:</strong></p>
  <p>Define and organize candidate education levels to match job criteria. Easily link qualifications to roles and profiles to maintain consistency and streamline the screening process.</p>
</div>
`,
    },
    group: "masterData",
  },
  {
    id: "ManageSources",
    element: "#ManageSources",
    popover: {
      title: "Manage Sources",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Streamline and evaluate your sourcing channels:</strong></p>
  <p>Manage all recruitment sources from one place. Track their performance and optimize your sourcing strategy to attract the best candidates efficiently.</p>
</div>
`,
    },
    group: "masterData",
  },
  {
    id: "LetterConfiguration",
    element: "#LetterConfiguration",
    popover: {
      title: "Letter Configuration",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Create reusable letter templates for candidates:</strong></p>
  <p>Define HTML letter bodies with placeholders (for example offer letters) so your team can generate consistent documents.</p>
</div>

    `,
    },
    group: "masterData",
  },
  {
    id: "accessManagement",
    element: "#accessManagement",
    popover: {
      title: "Access Management",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Define how users access the system and integrate with external platforms:</strong></p>
  <p>This section allows you to configure authentication methods and connect third-party tools for seamless interview and collaboration experiences.</p>
</div>`,
    },
    group: "accessManagement",
  },
  {
    id: "PlatformIntegrations",
    element: "#PlatformIntegrations",
    popover: {
      title: "Platform Integrations",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
      <p><strong>Set up and manage virtual interview platform integrations:</strong></p>
      <p>Integrate platforms like Microsoft Teams, Zoom, and more to enable smooth scheduling and hosting of interviews. Credentials are stored securely to ensure a seamless and secure virtual meeting experience.</p>
    </div>

    `,
    },
    group: "accessManagement",
  },
  {
    id: "AuthConfiguration",
    element: "#AuthConfiguration",
    popover: {
      title: "Auth Configuration",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Secure and simplify access with Single Sign-On (SSO):</strong></p>
  <p>Integrate trusted SSO providers using protocols OAuth to enable seamless user authentication. Auth Configuration centrally and ensure secure, one-click access across your hiring platform.</p>
</div>

    `,
    },
    group: "accessManagement",
  },
  {
    id: "systemConfiguration",
    element: "#systemConfiguration",
    popover: {
      title: "System Configuration",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Set up and maintain system-level settings for smooth operations.</strong></p>
  <p>This section allows administrators to configure core functionalities such as email notifications, scheduled tasks (cron jobs), and other platform-wide behaviors.</p>
</div>`,
    },
    group: "systemConfiguration",
  },
  {
    id: "EmailConfiguration",
    element: "#EmailConfiguration",
    popover: {
      title: "Email Configuration",
      description: `
      <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Personalize and standardize your email communications:</strong></p>
  <p>Easily customize templates for various notifications, personalize subject lines and content, and maintain consistent branding and tone across all outgoing emails.</p>
</div>

    `,
    },
    group: "systemConfiguration",
  },
  {
    id: "CronConfiguration",
    element: "#CronConfiguration",
    popover: {
      title: "Cron Configuration",
      description: `
  <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
  <p><strong>Automate and schedule tasks with cron job configurations:</strong></p>
  <p>Set up cron schedules to automate tasks according to your needs. Customize intervals (e.g., hourly, daily, weekly) to ensure smooth operations and timely task execution.</p>
</div>

`,
    },
    group: "systemConfiguration",
  },
  {
    id: "Reports",
    element: "#Reports",
    popover: {
      title: "Reports",
      description: `
        <div style="font-family: 'Poppins', sans-serif; font-size: 16px; line-height: 1.6;">
        <p><strong>Get key recruitment insights with comprehensive reports:</strong></p>
        <p><strong>Offer to Joining:</strong> Track candidates from offer to joining.</p>
        <p><strong>Interview Summary:</strong> View interview outcomes at a glance.</p>
        <p><strong>Referral Report:</strong> Measure referral program success.</p>
        <p><strong>Candidate Feedback:</strong> Understand candidate experience.</p>
        <p><strong>Lead Time:</strong> Analyze time taken at each stage.</p>
        <p><strong>Recruitment Overview:</strong> Get a full process snapshot.</p>
      </div>`,
    },
    group: "Reports",
  },
];

export const CandidateStatus = [
  { statusId: 33, statusName: "Needs Second Opinion" },
  { statusId: 34, statusName: "Rejected" },
  { statusId: 35, statusName: "Can be considered" },
  { statusId: 36, statusName: "Suitable" },
  { statusId: 41, statusName: "On Hold" },
  { statusId: 42, statusName: "Offered" },
  { statusId: 43, statusName: "Accepted" },
  { statusId: 44, statusName: "Declined" },
  { statusId: 45, statusName: "Joined" },
  { statusId: 46, statusName: "Drop Out" },
  { statusId: 109, statusName: "Blacklist" },
  { statusId: 117, statusName: "Future Prospect" },
];

export const authTypeArr = Object.values(AuthType);

export const currencyOptions = {
  INR: {
    symbol: "₹",
    name: "Indian Rupee",
    code: "INR",
  },
  USD: {
    symbol: "$",
    name: "United States Dollar",
    code: "USD",
  },
  // Add more currencies as needed
};

export const planTypes = {
  monthly: {
    name: "Monthly",
    value: "monthly",
  },
  yearly: {
    name: "Yearly",
    value: "yearly",
  },
};

export const resumeParsingStatus = {
  PENDING : 'Pending',
  APPROVED : 'Approved',
  REJECTED: 'Rejected'
}
export type PlanStatus = 'pending' | 'accept' | 'approve' | 'payment received';

export const planStatusMessages: Record<PlanStatus, string> = {
  pending: 'Your plan request is pending. Please contact the administrator.',
  accept: 'Your plan request has been accepted and is awaiting approval.',
  approve: 'Your plan has been approved. Please proceed with the payment.',
  'payment received': 'Your plan has been successfully purchased and is queued. It will be activated after your current plan expires.',
};

export const  complexityLevelList = [
  {
    value: 1,
    label: "1 - Very Basic",
    description: "Very simple definitions or direct questions.",
  },
  {
    value: 2,
    label: "2 - Basic",
    description: "Basic concepts with minimal understanding required.",
  },
  {
    value: 3,
    label: "3 - Basic+",
    description: "Slightly deeper than basics, small logical thinking.",
  },

  {
    value: 4,
    label: "4 - Practical",
    description: "Basic real-world usage of concepts.",
  },
  {
    value: 5,
    label: "5 - Practical+",
    description: "Moderate real-world scenarios and usage.",
  },
  {
    value: 6,
    label: "6 - Applied",
    description: "Applied knowledge with problem-solving.",
  },

  {
    value: 7,
    label: "7 - Advanced",
    description: "Advanced concepts and tricky scenarios.",
  },
  {
    value: 8,
    label: "8 - Advanced+",
    description: "Complex logic, debugging, performance thinking.",
  },

  {
    value: 9,
    label: "9 - Expert",
    description: "Deep expertise, design thinking, trade-offs.",
  },
  {
    value: 10,
    label: "10 - Architect Level",
    description: "System design, scalability, and architecture decisions.",
  },
];

export const complexityGuide = [
  {
    range: "1–3",
    title: "Very Basic to Basic+",
    description:
      "Covers simple definitions, basic concepts, and straightforward questions with minimal logic.",
    color: "#28a745",
    icon: "🟢",
  },
  {
    range: "4–6",
    title: "Practical to Applied",
    description:
      "Focuses on real-world usage, practical scenarios, and applying concepts to solve problems.",
    color: "#ffc107",
    icon: "🟡",
  },
  {
    range: "7–8",
    title: "Advanced to Advanced+",
    description:
      "Includes complex logic, edge cases, debugging, and performance considerations.",
    color: "#fd7e14",
    icon: "🟠",
  },
  {
    range: "9–10",
    title: "Expert to Architect Level",
    description:
      "Involves deep expertise, system design, scalability, and architectural decision-making.",
    color: "#dc3545",
    icon: "🔴",
  },
];

export const planAttributeKeys = {
  interviewBot: "interview_bot",
  jobOpenings: "job_openings_count",
  resumeScreening: "resume_screening",
} as const;

export const AI_Provider = {
  OPENAI: "openai",
  AZURE: "azure",
} as const;